import React from 'react';

const SvgMd = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="MD_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="MD_svg__b" fill="#fff">
        <use xlinkHref="#MD_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#MD_svg__a" />
      <path fill="#EB1C43" mask="url(#MD_svg__b)" d="M13.333 0H28v20H13.333z" />
      <path fill="#115BCB" mask="url(#MD_svg__b)" d="M0 0h9.333v20H0z" />
      <path
        fill="#FFD953"
        mask="url(#MD_svg__b)"
        d="M9.333 0h9.333v20H9.333z"
      />
      <path
        d="M12 8h1.333L14 6l.667 2H16v4l-2 1.333L12 12V8zm1.333 1.333v2h1.334v-2h-1.334z"
        fill="#AF7F59"
        mask="url(#MD_svg__b)"
      />
    </g>
  </svg>
);

export default SvgMd;
